module.exports = __webpack_public_path__ + "static/media/graph_icon.d620e13f.svg";